export default __webpack_public_path__ + "static/media/brackets.547b8e23.svg";